<!-- 设计师别名管理 -->
<template>
<div>
	<!-- 标题 -->
	<div class="page-title">设计师别名管理</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 15px;position: sticky;left: 30px;z-index: 5;">
		
		<div class="screen-box" style="margin-bottom: 0;">
			<div class="screen-label">设计师名称</div>
			<a-input v-model="r_user_name" allowClear placeholder="请输入设计师名称" style="width: 220px;"/>
		</div>
		
		<div class="screen-box" style="margin-bottom: 0;">
			<div class="screen-label">后台用户主键id</div>
			<a-input v-model="r_admin_id" allowClear placeholder="请输入后台用户主键id" style="width: 220px;"/>
		</div>
		
		<a-button @click="searchButton('button')" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button>
		
		<a-button @click="addButton" style="background-color: #67c23a;border-color: #67c23a;" type="primary">+ 新增</a-button>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<!-- ID -->
			<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
				{{item.id}}
			</div>
			<!-- 简称/别名 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
				{{item.user_alias}}
			</div>
			<!-- 姓名 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
				{{item.user_name}}
			</div>
			<!-- 角色 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
				{{item.role_name}}
			</div>
			<!-- 绑定后台用户 -->
			<div @click="editAdminUser(item)" class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}" >
				
				<div v-if="item.admin_name.length > 0" style="display: flex;align-items: center;cursor: pointer;color: #2F88FF;flex-wrap: wrap;">
					{{item.admin_name}}
				</div>
				<div v-else style="color: #62a8ea;cursor: pointer;">
					未设置
				</div>
			</div>
			<!-- 操作 -->
			<div @click="editTable(index,item)" class="table-td-cell" :style="{'width': rableTitle[5].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
				编辑
			</div>
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
	</div>
	
	<!-- 分页 -->
	<div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 30px;">
		
		<a-pagination v-model="r_page" :pageSize="20" :total="table_total" @change="paginationChange" />
		
	</div>
	
	
	<!-- 新增/编辑的侧边栏 -->
	<a-drawer
	  :title="drawer_title"
	  width="550px"
	  placement="right"
	  :closable="false"
	  :visible="visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 10px;">
			<div class="form-cell-box">
				<div class="class-title">简称/别名<span class="required-hint">*</span></div>
					
				<a-input v-model="x_user_alias" placeholder="请输入" style="width: 240px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">姓名<span class="required-hint">*</span></div>
					
				<a-input v-model="x_user_name" placeholder="请输入" style="width: 240px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">角色<span class="required-hint">*</span></div>
					
				<a-select :value="x_user_role" style="width: 240px" placeholder="未选择"
				 @change="handleChangeA" >
					
					<a-select-option value="1">
						设计师
					</a-select-option>
				</a-select>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">绑定后台用户</div>
					
				<a-select :value="x_admin_id" style="width: 240px" placeholder="未选择"
				 @change="handleChangeB" allowClear>
					
					<a-select-option  v-for="(value,key) in userSelect" :key="key" :value="key">
						{{value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	<!-- 编辑单项的弹窗 -->
	<a-modal
	      :title="`编辑`"
	      :visible="edit_visible"
	      :confirm-loading="confirmLoading"
		  cancelText="取消"
		  okText="确认" 
		  width="500px" 
	      @ok="editModalOk"
	      @cancel="editModalCancel"
		  
	    >
		
		<div class="form-cell-box">
			<div class="class-title">绑定后台用户</div>
				
			<a-select :value="e_admin_id" style="width: 240px" placeholder="未选择"
			 @change="handleChangeC" allowClear>
				
				<a-select-option  v-for="(value,key) in userSelect" :key="key" :value="key">
					{{value}}
				</a-select-option>
			</a-select>
		</div>
		
	</a-modal>
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { toushouAliasList, channelAdd, channelEdit, logSelectUser, toushouAliasEdit, toushouAliasAdd } from '@/request/api'
export default {
	name: 'pitcherList_',
	components: {
		
	},
	data() {
		return {
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:120, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"简称/别名", width:180, type:"user_alias", },
				{title:"姓名", width:200, type:"user_name", },
				{title:"角色", width:200, type:"role_name", },
				{title:"绑定后台用户", width:200, type:"admin_name", },
				{title:"操作", width:120, type:"cz", },
			],
			tableShowData: [],
			table_scroll_width: 1000,
			search_button_loading: false,
			
			r_page: 1,
			table_total: 0,
			r_limit: 20,
			r_user_name: "", // 设计师名称
			r_admin_id: "", // 后台用户主键id
			
			drawer_title: "新增", // 侧边栏标题
			visible: false,
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			add_form_hint: "", // 侧边栏新增表单的验证提示
			
			x_channel_name: "", // 渠道名称
			x_channel_id: "", // 渠道ID
			x_return_point: "", // 渠道返点
			x_foreign_channel_id: 0, // 外部渠道ID
			x_type: "0", // 渠道类型 0=投放 1=运营
			x_id: "", // id，用于编辑
			
			x_user_alias: "", // 简称/别名
			x_user_name: "", // 姓名
			x_user_role: undefined, // 角色
			x_admin_id: undefined, // 绑定后台用户
			
			userSelect: {}, // 绑定后台用户下拉数据
			
			// 单个编辑弹窗
			edit_visible: false, // 编辑弹窗的显示
			edit_modal_title: "", // 编辑弹窗的标题
			confirmLoading: false,
			e_jump_url: "", // 编辑公众号关注页链接请求需要的参数
			e_wechatid: "", // 编辑微信ID请求需要的参数
			e_id: "", // 编辑请求用的id
			e_channel_id: undefined, // 渠道编辑
			e_applets_id: undefined, // 替换小程序
			
			e_admin_id: undefined, // 绑定后台用户
		}
	},
	mounted(){
		let that = this
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.table_scroll_width = table_info.table_width
		
		logSelectUser().then(res=>{
			console.log("获取所有的下拉",res);
			that.userSelect = res.data.data.list
		})
		
		that.searchButton()
	},
	methods:{
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			if(type != '分页'){
				that.r_page = 1
			}
			toushouAliasList({
				page: that.r_page,
				limit: that.r_limit,
				
				user_name: that.r_user_name, // 设计师名称
				admin_id: that.r_admin_id // 后台用户主键id
			}).then(res=>{
				console.log("设计师别名管理列表",res.data);
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 新增按钮
		addButton(){
			this.drawer_title = "新增"
			this.visible = true
		},
		// 编辑
		editTable(index,e){
			console.log(e);
			let that = this
			this.drawer_title = "编辑"
			
			this.x_id = e.id
			
			that.x_user_alias = e.user_alias // 简称/别名
			that.x_user_name = e.user_name // 姓名
			that.x_user_role = e.user_role.toString() // 角色
			if(e.admin_id){
				that.x_admin_id = e.admin_id.toString()  // 绑定后台用户
			}
			else {
				that.x_admin_id = undefined
			}
			
			this.visible = true
		},
		// 新增/编辑
		addRequest(){
			let that = this
			if(!that.x_user_alias){
				that.add_form_hint = "请填写简称/别名"
			}
			else if(!that.x_user_name){
				that.add_form_hint = "请填写姓名"
			}
			else if(!that.x_user_role){
				that.add_form_hint = "请选择角色"
			}
			else {
				that.add_button_loading = true
				if(that.drawer_title == "新增"){
					toushouAliasAdd({
						user_alias: that.x_user_alias, // 简称/别名
						user_name: that.x_user_name, // 姓名
						user_role: that.x_user_role, // 角色
						admin_id: that.x_admin_id // 绑定后台用户
					}).then(res=>{
						console.log("新增",res);
						that.add_button_loading = false
						if(res.data.code == 0){
							that.onCloseDrawer()
							that.$message.success('操作成功');
							that.searchButton()
						}
						else {
							that.$message.error(res.data.msg || "请求失败");
						}
					})
				}
				else if(that.drawer_title == "编辑"){
					toushouAliasEdit({
						id: that.x_id,
						user_alias: that.x_user_alias, // 简称/别名
						user_name: that.x_user_name, // 姓名
						user_role: that.x_user_role, // 角色
						admin_id: that.x_admin_id || 0 // 绑定后台用户
					}).then(res=>{
						console.log("编辑",res);
						that.add_button_loading = false
						if(res.data.code == 0){
							that.onCloseDrawer()
							that.$message.success('操作成功');
							that.searchButton()
						}
						else {
							that.$message.error(res.data.msg || "请求失败");
						}
					})
				}
				
			}
		},
		// 侧边栏关闭
		onCloseDrawer(){
			if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
				return
			}
			
			this.x_id = ""
			this.x_user_alias = "" // 简称/别名
			this.x_user_name = "" // 姓名
			this.x_user_role = undefined // 角色
			this.x_admin_id = undefined
			this.add_form_hint = ""
			
			this.visible = false
		},
		// 分页
		paginationChange(e){
			this.r_page = e
			this.searchButton('分页')
		},
		// 角色
		handleChangeA(e){
			console.log(e);
			this.x_user_role = e
		},
		// 绑定后台用户
		handleChangeB(e){
			console.log(e);
			this.x_admin_id = e
		},
		// 单项编辑-绑定后台用户
		handleChangeC(e){
			console.log(e);
			this.e_admin_id = e
		},
		// 编辑
		editAdminUser(e){
			let that = this
			console.log(e);
			
			this.x_id = e.id
			that.x_user_alias = e.user_alias // 简称/别名
			that.x_user_name = e.user_name // 姓名
			that.x_user_role = e.user_role.toString() // 角色
			
			if(e.admin_id){
				this.e_admin_id = e.admin_id.toString()
			}
			
			this.edit_visible = true
		},
		editModalOk(){
			let that = this
			that.confirmLoading = true
			toushouAliasEdit({
				id: that.x_id,
				user_alias: that.x_user_alias, // 简称/别名
				user_name: that.x_user_name, // 姓名
				user_role: that.x_user_role, // 角色
				admin_id: that.e_admin_id || 0 // 绑定后台用户
			}).then(res=>{
				console.log("编辑",res);
				that.confirmLoading = false
				if(res.data.code == 0){
					that.editModalCancel()
					that.$message.success('编辑成功');
					that.searchButton()
				}
				else {
					that.$message.error(res.data.msg || "请求失败");
				}
			})
		},
		editModalCancel(){
			let that = this
			this.e_admin_id = undefined
			this.edit_visible = false
		},
	},
	filters: {
		
	}
}	
</script>

<style scoped>

</style>